module.exports = __webpack_public_path__ + "img/erweima.c27a2dfa.jpeg";